import api from './api';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.hml-whatsappservice.consolare.com.br';

// Instância separada para rotas de mensagens (sem autenticação)
const messagesApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

export const whatsappService = {
  // Status da conexão
  async getStatus() {
    const response = await api.get('/api/whatsapp/status');
    return response.data;
  },

  // Gerar novo QR code
  async generateQR() {
    const response = await api.post('/api/whatsapp/generate-qr');
    return response.data;
  },

  // Desconectar WhatsApp
  async disconnect() {
    const response = await api.post('/api/whatsapp/disconnect');
    return response.data;
  },

  // Forçar reconexão
  async reconnect() {
    const response = await api.post('/api/whatsapp/reconnect');
    return response.data;
  },

  // Enviar mensagem de texto (sem autenticação)
  async sendTextMessage(phoneNumber, message, replyTo = null) {
    console.log('🔍 Debug - whatsappService.sendTextMessage chamado com:', { phoneNumber, message, replyTo });

    try {
      const response = await messagesApi.post('/api/messages/send-text', {
        phoneNumber,
        message,
        replyTo
      });
      console.log('🔍 Debug - Resposta da API:', response);
      return response.data;
    } catch (error) {
      console.error('🔍 Debug - Erro no whatsappService:', error);
      throw error;
    }
  },

  // Enviar mídia (sem autenticação)
  async sendMedia(phoneNumber, mediaUrl, caption = '', type = 'image') {
    const response = await messagesApi.post('/api/messages/send-media', {
      phoneNumber,
      mediaUrl,
      caption,
      type
    });
    return response.data;
  },

  // Verificar número (sem autenticação)
  async checkNumber(phoneNumber) {
    const response = await messagesApi.post('/api/messages/check-number', {
      phoneNumber
    });
    return response.data;
  },

  // Health check (sem autenticação)
  async healthCheck() {
    const response = await messagesApi.get('/health');
    return response.data;
  }
};
